// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-6f859dac] {\n  color: #7A869E;\n  font-size: 14px;\n}\n.el-descriptions[data-v-6f859dac] .cash-label {\n  width: 240px;\n  color: #98A1B4;\n  font-size: 16px;\n}\n.el-descriptions[data-v-6f859dac] .el-descriptions-item__container {\n  margin: 15px 0;\n}", ""]);
// Exports
module.exports = exports;
